<h2 mat-dialog-title>{{ action }} Tag</h2>
<form (ngSubmit)="processForm()" autocomplete="off">
  <div mat-dialog-content>
    <div class="row">
      <div class="col-12 mt-12" *ngIf="action == 'Delete'">
        <h4>Are you sure you want to delete {{ tag.name }}?</h4>
      </div>
      <div class="col-12 mt-2" *ngIf="action != 'Delete'">
        <mat-form-field class="w-100">
          <mat-label>Name</mat-label>
          <input type="text" matInput [(ngModel)]="tag.name" name="tag" maxlength="45" required />
        </mat-form-field>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-stroked-button mat-dialog-close>Cancel</button>
      <button
        type="submit"
        mat-stroked-button
        class="ml-2"
        [class]="action == 'Delete' ? 'danger' : 'success'"
        [disabled]="loading"
      >
        <span>{{ action }} Tag</span>
      </button>
    </div>
  </div>
</form>
